/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import React from 'react'
import './Menu.scss'
import { injectProperty } from '../../arc/configuration/ServiceLocator'
import { ITopNavBarApiClient } from '../../services/TopNavBarApiClient/contracts'
import { SettingsManager } from '../../configuration/SettingsManager'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IMenuProps {
	//code related to your props goes here
}

export interface IMenuState {
	authorizedForFacility: boolean
}

export class Menu extends React.Component<IMenuProps, IMenuState> {
	@injectProperty('ITopNavBarApiClient')
	public topNavBarApiClient!: ITopNavBarApiClient

	constructor(props: Readonly<IMenuProps>) {
		super(props)

		this.state = {
			authorizedForFacility: false,
		}
	}

	componentDidMount(): void {
		let numOfExtraMenus = 0
		this.topNavBarApiClient.getAuthorizationStatus(SettingsManager.PRODUCT_PERMISSION_FOR_FACILITY_CONFIGURATION).then(response => {
			if (response === true) {
				this.setState({
					authorizedForFacility: true,
				})
				numOfExtraMenus++
				if (window.parent.hasOwnProperty('setFrameHeight') && typeof window.parent['setFrameHeight'] === 'function') {
					const heightMenu = 110 + numOfExtraMenus * 24
					window.parent['setFrameHeight'].call(this, 'iframeHeaderacd', heightMenu)
				}
			}
		})

		if (window.parent.hasOwnProperty('setFrameHeight') && typeof window.parent['setFrameHeight'] === 'function') {
			const heightMenu = 110 + numOfExtraMenus * 24
			window.parent['setFrameHeight'].call(this, 'iframeHeaderacd', heightMenu)
		}
	}
	render(): React.ReactNode {
		return (
			<div className="menu-main">
				<div className="menu-header">
					<span style={{ color: '#003D79' }}>Insurance Discovery</span>
				</div>
				<div className="menu-body">
					<table>
						<tr>
							<td className="menu-bodyrequest">
								<a href="/coveragediscovery/coveragediscoveryrequest/" target="_parent">
									<i className="request"></i>
									<span className="menu-panel">Request</span>
								</a>
							</td>
						</tr>
						<tr>
							<td className="menu-body">
								<a href="/coveragediscovery/requesthistory/" target="_parent">
									<i className="document"></i>
									<span className="menu-panel">History</span>
								</a>
							</td>
						</tr>
						<tr>
							<td className="menu-body">
								<a href="/coveragediscovery/batches/" target="_parent">
									<i className="batches"></i>
									<span className="menu-panel">Batches</span>
								</a>
							</td>
						</tr>
						{this.state.authorizedForFacility ? (
							<tr>
								<td className="menu-body">
									<a href="/coveragediscovery/facilities/" target="_parent">
										<i className="gear"></i>
										<span className="menu-panel">Facilities</span>
									</a>
								</td>
							</tr>
						) : null}
					</table>
				</div>
			</div>
		)
	}
}
